<template>
    <div>
        <b-row>
            <b-col sm="6">
                <label>Cabinet Expertise Comptable</label>
                <b-select
                    v-model="form.accounting_firm_company_id"
                    :options="accountingFirmCompanyOptions"
                    @input="showNotSaved"
                />
            </b-col>
            <b-col sm="6">
                <label>Cabinet Social</label>
                <b-select
                    v-model="form.accounting_firm_company2_id"
                    :options="accountingFirmCompanyOptions"
                    @input="showNotSaved"
                />
            </b-col>
        </b-row>

        <div class="row mt-3">
            <div class="col-4">
                <b-form-group>
                    <label>Nom court</label>
                    <b-input
                        v-model="form.short_name"
                        :state="!$v.form.short_name.$invalid"
                        @input="showNotSaved"
                    />
                    <b-form-invalid-feedback id="message-feedback">
                        <span v-if="!$v.form.short_name.required">
                            10 caractères max.
                        </span>
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-4">
                <label>Code interne</label>
                <b-input v-model="form.unique_code" @input="showNotSaved"/>
            </div>

            <!--                TODO (temporarily disabled)-->
            <div class="col-3" v-if="false">
                <label>Code comptable</label>
                <b-input v-model="form.accounting_code" @input="showNotSaved"/>
            </div>
            <div class="col-4">
                <label>Type de prestations</label>
                <b-select
                    v-model="form.service_type"
                    :options="serviceOptions"
                    @change="showNotSaved"
                />
            </div>
        </div>

        <hr v-if="showOutDate"/>
        <div v-if="showOutDate" class="row">
            <div class="col-6">
                <label>Date d'entrée</label>
                <b-input-group class="mb-3">
                    <b-form-input
                        id="in-date"
                        v-model="formatted_in_date"
                        type="text"
                        placeholder="Non définie"
                        autocomplete="off"
                        disabled
                        class="bg-white"
                    />
                    <b-input-group-append>
                        <b-form-datepicker
                            v-model="form.in_date"
                            button-only
                            right
                            reset-button
                            close-button
                            label-close-button="Fermer"
                            label-reset-button="Effacer"
                            label-no-date-selected="Non définie"
                            label-prev-year="Année précédente"
                            label-next-year="Année prochaine"
                            label-prev-month="Mois précédent"
                            label-next-month="Mois prochain"
                            label-current-month="Mois actuel"
                            label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                            start-weekday="1"
                            aria-controls="in-date"
                            :date-format-options="{
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                            }"
                            locale="fr"
                            @context="formatInDate"
                            @input="showNotSaved"
                        >
                        </b-form-datepicker>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div class="col-6">
                <div>
                    <label>Date de sortie</label>
                    <b-input-group class="mb-3">
                        <b-form-input
                            id="out-date"
                            v-model="formatted_out_date"
                            type="text"
                            placeholder="Non définie"
                            autocomplete="off"
                            disabled
                            class="bg-white"
                        />
                        <b-input-group-append>
                            <b-form-datepicker
                                v-model="form.out_date"
                                button-only
                                right
                                reset-button
                                close-button
                                label-close-button="Fermer"
                                label-reset-button="Effacer"
                                label-no-date-selected="Non définie"
                                label-prev-year="Année précédente"
                                label-next-year="Année prochaine"
                                label-prev-month="Mois précédent"
                                label-next-month="Mois prochain"
                                label-current-month="Mois actuel"
                                label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                                start-weekday="1"
                                aria-controls="in-date"
                                :date-format-options="{
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                }"
                                locale="fr"
                                @context="formatOutDate"
                                @input="showNotSaved"
                            >
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
        </div>
        <div v-if="form.out_date !== null">
            <b-form-group>
                <label>Motif de départ</label>
                <b-form-select
                    v-model="form.departure_option_id"
                    :options="departureOptions"
                    :disabled="form.out_date === null"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            --- Sélectionner un motif ---
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <label>Commentaires</label>
            <b-form-textarea
                v-model="form.departure_comments"
                rows="3"
                max-rows="6"
                class="mb-3"
            />
        </div>
        <b-alert variant="success" :show="showSavedAlert">
            Les modifications ont bien été enregistrées
        </b-alert>
        <b-alert variant="danger" :show="showNotSavedAlert">
            Les modifications ne sont pas enregistrées
        </b-alert>
        <b-button
            variant="success"
            class="mt-2"
            :disabled="$v.$invalid"
            title="Enregistrer"
            @click="internalDataSave"
        >
            <i class="fal fa-save fa-fw"></i>
            <span class="pl-2">Enregistrer</span>
        </b-button>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {maxLength} from 'vuelidate/lib/validators'
import Formatter from '../../../../common/mixins/Formatter.vue'

export default {
    name: 'InternalForm',

    mixins: [Formatter],

    props: {
        company: {
            type: Object,
            required: true,
        },
        showOutDate: {
            type: Boolean,
            required: true,
        },
        departureOptions: {
            type: Object,
            required: true,
        },
        serviceOptions: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            form: {
                short_name: '',
                accounting_firm_company_id: null,
                accounting_firm_company2_id: null,
            },
            formatted_in_date: '',
            formatted_out_date: '',
            showSavedAlert: false,
            showNotSavedAlert: false,
        }
    },
    validations: {
        form: {
            short_name: {
                maxLength: maxLength(10),
            },
        },
    },
    created() {
        this.initForm()
    },
    methods: {
        showNotSaved() {
            this.showSavedAlert = false
            this.showNotSavedAlert = true
        },
        showSaved() {
            this.showSavedAlert = true
            this.showNotSavedAlert = false
        },
        initForm() {
            this.form.accounting_firm_company_id = this.company
                .accounting_firm_company
                ? this.company.accounting_firm_company.id
                : null
            this.form.accounting_firm_company2_id = this.company
                .accounting_firm_company2
                ? this.company.accounting_firm_company2.id
                : null
            this.form.unique_code = this.company.unique_code
            this.form.accounting_code = this.company.accounting_code
            this.form.service_type = this.company.service_type
            this.form.short_name = this.company.short_name
            this.form.in_date = this.company.in_date
            this.form.out_date = this.company.out_date
            this.form.departure_comments = this.company.departure_comments
            this.form.departure_option_id =
                this.company.departure_option_id > 0
                    ? this.company.departure_option_id
                    : null
        },
        async internalDataSave() {
            try {
                await axios.put(
                    `clients/${this.company.id}/internal`,
                    this.form
                )
                this.showSaved()
            } catch (error) {
                console.log(error)
            }
        },
        formatInDate(ctx) {
            this.formatted_in_date = ctx.selectedFormatted
        },
        formatOutDate(ctx) {
            this.formatted_out_date = ctx.selectedFormatted
        },
    },
    computed: {
        ...mapState({
            accountingFirmCompanies: (state) =>
                state.data.options.accountingFirmCompanies,
        }),

        accountingFirmCompanyOptions() {
            const options = this.accountingFirmCompanies.filter(
                (item) => item.value > 0
            )
            const nullOption = [{value: null, text: 'Non déterminé', disabled: true}]
            return nullOption.concat(options)
        },
        departureSelectDisabled() {
            return this.form.out_date === null
        },
    },
}
</script>

<style scoped></style>
